import { nodePaths } from '../../server/globalVariables';
import { pathToRegexp } from 'path-to-regexp';

export default function determineSwitchPath(path) {
  //This function is used to determing what content component to render.
  //Will be stored in state at the app level.
  let keys = [],
    chosenNodePathIndex,
    resolvedPathVariables;

  for (let i = 0; i < nodePaths.length; i++) {
    if (!resolvedPathVariables) {
      keys = [];
      const currentNodePathToTest = nodePaths[i];
      const re = pathToRegexp(currentNodePathToTest, keys);
      resolvedPathVariables = re.exec(path);
      if (resolvedPathVariables) chosenNodePathIndex = i;
    } else {
      break;
    }
  }
  return nodePaths[chosenNodePathIndex] || '';
}
